<template>
  <div class="card height-equal">
    <div class="card-header">
      <h2> Book a Ride </h2>
    </div>
    <div id="wizard">
      <div class="card-body">
        <div class="horizontal-wizard-wrapper">
          <div class="row">
            <!-- Navigation tab-->
            <div class="col-12 main-horizontal-header mb-3 border-1" id="booking-wizard">
              <div class="nav nav-pills horizontal-options" id="vertical-wizard-tab" role="tablist"
                   aria-orientation="vertical">

                <a class="nav-link" id="wizard-v-info-tab" data-bs-toggle="pill" href="#trip-details" role="tab"
                   aria-controls="wizard-v-info" aria-selected="true">
                  <div class="horizontal-wizard">
                    <div class="stroke-icon-wizard"><i class="fa-solid fa-map-location-dot"></i></div>
                    <div class="horizontal-wizard-content">
                      <h5 class="f-w-600">Trip Details</h5>
                    </div>
                  </div>
                </a>

                <a class="nav-link" id="inquiry-v-wizard-tab" data-bs-toggle="pill" href="#passenger-details" role="tab"
                   aria-controls="inquiry-v-wizard" aria-selected="false">
                  <div class="horizontal-wizard">
                    <div class="stroke-icon-wizard"><i class="fa-solid fa-user-group"></i></div>
                    <div class="horizontal-wizard-content">
                      <h5 class="f-w-600">Passenger Details</h5>
                    </div>
                  </div>
                </a>

                <a class="nav-link" id="successful-v-wizard-tab" data-bs-toggle="pill" href="#dispatch" role="tab"
                   aria-controls="successful-v-wizard" aria-selected="false">
                  <div class="horizontal-wizard">
                    <div class="stroke-icon-wizard"><i class="fa-solid fa-taxi"></i></div>
                    <div class="horizontal-wizard-content">
                      <h5 class="f-w-600">Dispatch</h5>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <!-- tabs -->
            <div class="col-12 tab-content dark-field" id="wizard-tab-content">

              <!-- Trip Details Tab -->
              <div class="tab-pane fade active show wizard-content" id="trip-details" role="tabpanel"
                   aria-labelledby="trip-details-tab">
                <div class="row">
                  <div class="col-sm-6 mb-3">
                    <label class="form-label f-w-600" for="account-select">Account</label>
                    <select id="account-select" class="form-select" v-model="selectedAccount">
                      <option :value="null">No Account</option>
                      <option v-for="account in accounts" :key="account.id" :value="account.id">
                        {{ account.companyName }} ({{ account.accountCode }})
                      </option>
                    </select>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="mb-3">
                      <label class="form-label f-w-600" for="pickup-location-input">Pickup Location</label>
                      <input id="pickup-location-input" class="form-control" ref="pickupInput"
                             v-model="pickUpInfo.value" type="text" placeholder="Start typing..."/>
                      <div id="pickup-location-error" class="invalid-feedback d-none">Please enter an address
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Skip Drop-Off Location Checkbox -->
                <div class="row mb-3">
                  <div class="col-12">
                    <div class="form-check checkbox">
                      <input type="checkbox" id="skip-drop-off-location" class="form-check-input"
                             v-model="skipDropOffLocation"/>
                      <label class="form-check-label f-w-600" for="skip-drop-off-location">
                        Skip Drop-Off Location
                      </label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <div class="mb-3">
                      <label class="form-label f-w-600" for="drop-off-location-input">Drop-Off
                        Location</label>
                      <input id="drop-off-location-input" class="form-control" ref="dropOffInput"
                             v-model="dropOffInfo.value" :disabled="skipDropOffLocation" type="text"
                             placeholder="Start typing..."/>

                      <div id="drop-off-location-error" class="invalid-feedback d-none">
                        Please enter an address
                      </div>

                    </div>
                  </div>
                </div>
              </div>

              <!-- Passenger Details Tab -->
              <div class="tab-pane fade wizard-content" id="passenger-details" role="tabpanel">
                <div class="row mb-3">
                  <div class="col-12">
                    <div class="form-check checkbox">
                      <input type="checkbox" id="skip-passenger-info" class="form-check-input"
                             v-model="skipPassengerInfo"/>
                      <label class="form-check-label f-w-600" for="skip-passenger-info">
                        Skip Passenger Details
                      </label>
                    </div>
                  </div>
                </div>


                <div class="row">
                  <div class="col-sm-7 mb-3">
                    <label class="form-label f-w-600" for="passenger-name-input">Passenger Name (Optional)</label>
                    <input id="passenger-name-input" class="form-control" v-model="passengerName"
                           :disabled="skipPassengerInfo" type="text" placeholder="Johnny Smith"/>
                    <div id="passenger-name-error" class="invalid-feedback d-none">
                      Please enter the passenger name
                    </div>
                  </div>

                  <div class="col-sm-5 mb-3">
                    <label class="form-label f-w-600" for="passenger-contact-input">Contact Number (Optional)</label>
                    <input id="passenger-contact-input" class="form-control" v-model="passengerContact"
                           :disabled="skipPassengerInfo" type="tel" placeholder="123-456-7890"/>
                    <div id="passenger-contact-error" class="invalid-feedback d-none">
                      Please enter a valid contact number
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6 mb-3">
                    <label class="form-label f-w-600" for="passenger-number-input">Number of Passengers</label>
                    <div class="touchspin-wrapper">
                      <button type="button" class="decrement-touchspin btn-touchspin spin-border-primary"
                              :disabled="skipPassengerInfo" @click="decrementPassengers">
                        <i class="fa-solid fa-minus"></i>
                      </button>
                      <input class="input-touchspin spin-outline-primary me-1 ms-1" type="number"
                             id="passenger-number-input" :disabled="skipPassengerInfo" v-model="numPassengers" min="1">
                      <button type="button" class="increment-touchspin btn-touchspin spin-border-primary"
                              :disabled="skipPassengerInfo" @click="incrementPassengers">
                        <i class="fa-solid fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>


              </div>

              <!-- Dispatch Tab -->
              <div class="tab-pane fade wizard-content" id="dispatch" role="tabpanel" aria-labelledby="dispatch">
                <div v-if="isLoadingEstimates" class="row mb-3">
                  <div class="col-12 text-center">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-2">Fetching estimates...</p>
                  </div>
                </div>

                <div v-else>
                  <div v-if="!isDriverAvailable" class="row mb-3">
                    <div class="col-12">
                      <div class="alert alert-warning" role="alert">
                        No drivers available at this time.
                      </div>
                    </div>
                  </div>

                  <div v-else class="row">
                    <div class="col-sm-6 mb-3">
                      <label class="form-label f-w-600">Time to Pickup</label>
                      <p class="form-control-static">{{ estimatedTimeOfArrival }}</p>
                    </div>

                    <div v-if="!skipDropOffLocation" class="col-sm-6 mb-3">
                      <label class="form-label f-w-600">Time for Trip</label>
                      <p class="form-control-static">{{ estimatedTripTime }}</p>
                    </div>

                    <div class="col-sm-6 mb-3">
                      <label class="form-label f-w-600">Estimated Fare</label>
                      <p class="form-control-static" v-if="estimatedCost > 0">${{ estimatedCost }}</p>
                      <p class="form-control-static" v-else>Not available</p>
                    </div>
                  </div>
                </div>


                <div class="row">
                  <div class="col-sm-6 mb-3">
                    <label class="form-label f-w-600" for="auto-assign-check">Auto Assign</label>
                    <div class="form-check-size">
                      <div class="form-check form-switch form-check-inline">
                        <input v-model="autoAssignCheck" class="form-check-input check-size" id="auto-assign-check"
                               type="checkbox" role="switch">
                      </div>
                    </div>
                  </div>

                  <div v-if="!autoAssignCheck" class="col-sm-6 mb-3">
                    <label class="form-label f-w-600" for="select-driver">Select Driver</label>
                    <input id="select-driver" class="form-control" ref="driverInput" v-model="driverInfo" type="text"
                           placeholder="Start typing to search for drivers..."/>
                    <div id="select-driver-error" class="invalid-feedback d-none">
                      Please select a driver or else enable auto-assign.
                    </div>
                  </div>

                </div>

                <div class="row">
                  <div class="col-12 mb-3">
                    <label class="form-label f-w-600" for="driver-notes">Driver Notes</label>
                    <textarea id="driver-notes" class="form-control" v-model="driverNotes" rows="3"
                              placeholder="Enter notes for driver..."></textarea>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="card-footer">
        <!--  The navigation buttons will be inserted here -->
        <div id="navigation-button-container"></div>
      </div>
    </div>

  </div>
</template>

<script setup>
import {ref, watch, onMounted, onUnmounted, nextTick} from 'vue';
import 'jquery-ui';
import './../../extras/js/jquery-wizard';
import {notificationType, showToast} from "../utility/toastNotificationUtility";
import {eventBus} from '../utility/eventBus';
import {renderWithPoi} from '../utility/addressHelper'

// Props
const props = defineProps({
  pickUpData: {type: [Object, String], default: '', required: true},
  dropOffData: {type: [Object, String], default: '', required: true},
  serviceProviderId: {type: String, required: true}
});

// Emits
const emit = defineEmits(['update:pickUpData', 'update:dropOffData', 'drawDriverOnMap', 'resetForm']);

// Reactive state
const pickUpInfo = ref('');
const dropOffInfo = ref('');
const skipDropOffLocation = ref(false);

const skipPassengerInfo = ref(false);
const passengerName = ref('');
const passengerContact = ref('');
const numPassengers = ref(1);
const selectedAccount = ref(null);
const accounts = ref([]);

const estimatedCost = ref(0.0);
const estimatedTimeOfArrival = ref('');
const estimatedTripTime = ref('');
const isDriverAvailable = ref(true);
const isLoadingEstimates = ref(false);
const autoAssignCheck = ref(true);
const driverInfo = ref('');
const driverNotes = ref('');

// Refs for DOM elements. They will be automatically bound to their respective refs in the dom
let pickupInput = null;
let dropOffInput = null;
let driverInput = null;

// Methods
const addressAutoCompleteInit = (refElement, updateEvent) => {
  $(refElement).autocomplete({
    source: (request, response) => {
      fetch(`/api/dispatch-ride/autocomplete?query=${encodeURIComponent(request.term)}`)
          .then((res) => {
            if (!res.ok) {
              throw new Error(`HTTP error! status: ${res.status}`);
            }
            return res.json();
          })
          .then((data) => {
            const suggestions = data.results.map((result) => ({
              label: renderWithPoi(result),
              value: result.name,
              result,
            }));
            response(suggestions);
          })
          .catch((error) => {
            console.error('Error fetching suggestions:', error);
            response([]);
          });
    },
    minLength: 3,
  }).on('autocompleteselect', (event, ui) => {
    if (updateEvent === 'pickUp') {
      pickUpInfo.value = ui.item;
      emit('update:pickUpData', ui.item);
    } else if (updateEvent === 'dropOff') {
      dropOffInfo.value = ui.item;
      emit('update:dropOffData', ui.item);
    }
  }).autocomplete('instance')._renderItem = (ul, item) => {
    return $('<li>').append(item.label).appendTo(ul);
  };
};

const driverSelectionAutoCompleteInit = () => {
  $(driverInput).autocomplete({
    source: (request, response) => {
      fetch(`/api/dispatch-ride/query-available-drivers?query=${request.term}`)
          .then((res) => {
            if (!res.ok) {
              throw new Error(`HTTP error! status: ${res.status}`);
            }
            return res.json();
          })
          .then((data) => {
            const suggestions = data.map((driver) => ({
              label: `
              <div>
                <strong>${driver.name}</strong> <small>(${driver.vehicleType})</small>
              </div>`,
              value: driver.name,
              driver,
            }));
            response(suggestions);
          });
    },
    minLength: 2,
    select: (event, ui) => {
      driverInfo.value = ui.item.value;
      emit('drawDriverOnMap', ui.item.driver);
    },
  }).autocomplete('instance')._renderItem = (ul, item) => {
    return $('<li>').append(item.label).appendTo(ul);
  };
};

const fetchEstimates = async () => {
  if (pickUpInfo.value.result && (dropOffInfo.value.result || skipDropOffLocation.value)) {
    const originPlaceId = pickUpInfo.value.result.id;
    const destinationPlaceId = skipDropOffLocation.value ? '' : dropOffInfo.value.result.id;

    try {
      isLoadingEstimates.value = true;
      const response = await fetch(
          `/api/dispatch-ride/get-estimates?originPlaceId=${encodeURIComponent(originPlaceId)}&destinationPlaceId=${encodeURIComponent(destinationPlaceId)}`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      // Update values based on the response
      estimatedCost.value = data.estimatedFare || 0.0;
      estimatedTimeOfArrival.value = data.timeToPickupString || 'N/A';
      estimatedTripTime.value = data.timeToDestinationString || 'N/A';
      isDriverAvailable.value = data.driverAvailable !== false; // Default to true if not specified
    } catch (error) {
      console.error('Error fetching estimates:', error);
      // Reset values on error
      estimatedCost.value = 0.0;
      estimatedTimeOfArrival.value = 'Error fetching data';
      estimatedTripTime.value = '';
      isDriverAvailable.value = false;
    } finally {
      isLoadingEstimates.value = false;
    }
  } else {
    console.error('Pickup and Drop-off data must be provided to fetch estimates.');
  }
};

const completeBooking = async () => {

  // Assemble Ride object
  const rideObject = {
    pickupLocation: pickUpInfo.value.result || null,
    dropOffLocation: skipDropOffLocation.value ? null : dropOffInfo.value.result || null,
    passengerDetails: skipPassengerInfo.value
        ? null
        : {
          name: passengerName.value,
          contact: passengerContact.value,
          numPassengers: numPassengers.value,
        },
    autoAssign: autoAssignCheck.value,
    driverId: autoAssignCheck.value ? null : driverInfo.value.id,
    driverNotes: driverNotes.value,
    accountId: selectedAccount.value
  };

  try {
    // Post the ride object to the backend
    const response = await fetch('/api/dispatch-ride/create-ride', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(rideObject),
    });

    if (!response.ok) {

      showToast({
        title: "Error",
        body: await response.text(),
        type: notificationType.ERROR,
        delay: 6000,
      });
    } else {

      // Reset the form fields
      emit('resetForm', {});
      showToast({
        title: "Booking Completed!",
        body: `Ride successfully booked.`,
        type: notificationType.SUCCESS,
        delay: 6000,
      });
    }

  } catch (error) {
    console.error('Error completing booking:', error);

    showToast({
      title: "Error",
      body: "Failed to complete booking. Please try again later.",
      type: "error",
      delay: 6000,
    });
  }
};


const incrementPassengers = () => {
  numPassengers.value++;
};

const decrementPassengers = () => {
  if (numPassengers.value > 1) {
    numPassengers.value--;
  }
};


//validations
const tripDetailIsValid = () => {
  let valid = true;
  if (!pickUpInfo.value.label) {
    valid = false;
    $('#pickup-location-input').addClass('is-invalid');
    $('#pickup-location-error').removeClass('d-none');
  } else {
    $('#pickup-location-input').removeClass('is-invalid');
    $('#pickup-location-error').addClass('d-none');
  }

  if (!skipDropOffLocation.value) {
    if (!dropOffInfo.value.label) {
      valid = false;
      $('#drop-off-location-input').addClass('is-invalid');
      $('#drop-off-location-error').removeClass('d-none');
    } else {
      $('#drop-off-location-input').removeClass('is-invalid');
      $('#drop-off-location-error').addClass('d-none');
    }
  } else {
    $('#drop-off-location-input').removeClass('is-invalid');
    $('#drop-off-location-error').addClass('d-none');
  }

  return valid;
};

const passengerDetailIsValid = () => {
  let valid = true;
  if (!skipPassengerInfo.value) {
    //todo for now do nothing, we need to understand what is needed here and what should be included by all means
  }

  return valid;
}

const dispatchDetailIsValid = () => {
  let valid = true;
  if (!autoAssignCheck.value) {
    if (!driverInfo.value) {
      valid = false;
      $('#select-driver').addClass('is-invalid');
      $('#select-driver-error').removeClass('d-none');
    } else {
      $('#select-driver').removeClass('is-invalid');
      $('#select-driver-error').addClass('d-none');
    }
  }

  return valid;
}

// Watchers
watch(autoAssignCheck, async (newVal) => {
  if (!newVal) {
    //when the auto-assign is unchecked we have to wait for the dom to init autocomplete
    await nextTick();
    driverSelectionAutoCompleteInit();
  } else {
    // Clear driver info when auto-assign is enabled
    driverInfo.value = '';
    if (driverInput) {
      $(driverInput).autocomplete('close');
    }
  }
});


const setupWizard = () => {
  $('#wizard').wizard({
    step: '.nav-pills > a',
    classes: {
      step: {
        active: 'active',
      },
      pane: {
        active: 'active show'
      },
      button: {
        hide: 'd-none',
        disabled: 'd-none'
      }
    },
    buttonsAppendTo: '#navigation-button-container',
    templates: {
      buttons: function () {
        return `<div class="pull-left">
                        <a role="button" class="btn btn-outline-secondary mb-3" href="#wizard" data-wizard="back">Back</a>
                    </div>

                    <div class="pull-right">
                      <a role="button" class="btn btn-outline-primary mb-3" href="#wizard" data-wizard="next">Next</a>
                      <a role="button" class="btn btn-outline-success mb-3" href="#wizard" data-wizard="finish">Dispatch</a>
                    </div>`;
      }
    },
    validator: function (step) {
      if (step.index === 0) {
        return tripDetailIsValid();
      }

      if (step.index === 1) {
        return passengerDetailIsValid();
      }

      if (step.index === 2) {
        return dispatchDetailIsValid();
      }

      return false;
    },
    onAfterChange: function (currentStep, nextStep) {
      if (nextStep.index === 2) {
        // Fetch estimates when moving to the dispatch step (final step)
        fetchEstimates();
      }
    },
    onFinish: function () {
      completeBooking();
    }
  });
};

const insertPassengerPhoneNumber = async (data) => {
  passengerContact.value = data;
}

const insertPickUpInfoFromCall = async (data) => {
  pickUpInfo.value = data
  emit('update:pickUpData', pickUpInfo.value);
};

const insertDropOffInfoFromCall = (data) => {
  skipDropOffLocation.value = false;
  dropOffInfo.value = data;
  emit('update:dropOffData', dropOffInfo.value);
}

async function fetchActiveAccounts() {
  try {
    const response = await fetch(`/api/service-providers/${props.serviceProviderId}/accounts/active`);
    if (response.ok) {
      accounts.value = await response.json();
    }
  } catch (error) {
    console.error('Error fetching active accounts:', error);
  }
}

// Lifecycle Hooks
onMounted(() => {
  fetchActiveAccounts();
  nextTick(() => {
    setupWizard();
    addressAutoCompleteInit(pickupInput, 'pickUp');
    addressAutoCompleteInit(dropOffInput, 'dropOff');

    eventBus.on('emitPickupSuggestionToForm', insertPickUpInfoFromCall);
    eventBus.on('emitDropOffSuggestionToForm', insertDropOffInfoFromCall);
    eventBus.on('emitCallerPhoneNumber', insertPassengerPhoneNumber);
  });
});

onUnmounted(() => {
  eventBus.off('emitPickupSuggestionToForm', insertPickUpInfoFromCall);
  eventBus.off('emitDropOffSuggestionToForm', insertDropOffInfoFromCall);
  eventBus.off('emitCallerPhoneNumber', insertPassengerPhoneNumber);
});

</script>